import { SyntheticEvent, useState } from "react";
import { CATEGORY, PLATFORMS, SCREENS } from "../../constants";
import { useWidth } from "../../hooks/useWidth";
import { setFormState, setFormData } from "../../redux/contact";
import { useAppDispatch, useAppSelector } from "../../redux/hooks";
import YudlButton from "../Button";
import YudlInput from "../Input";
import YudlModal from "../Modal";
import YudlSelect from "../Select";
import Close from "../Icons/Close";
import YudlTextArea from "../TextArea";
import "./style.css";
import { submitForm } from "../../redux/contact/contactThunk";

const ContactForm = () => {
    const [inValidSelect, setInValidSelect] = useState({ category: false, platform: false });

    const { showForm, formData, processing } = useAppSelector(state => state.contact);

    const dispatch = useAppDispatch();

    const { width } = useWidth();

    const handleSubmit = (e: SyntheticEvent<HTMLFormElement>) => {
        e.preventDefault();
        if (!formData.category) {
            setInValidSelect(prevState => ({ ...prevState, category: true }));
        }

        if (!formData.platform) {
            setInValidSelect(prevState => ({ ...prevState, platform: true }));
        }

        if (!e.currentTarget.checkValidity()) {
            e.currentTarget.classList.add("was-validated");
            return;
        }
        e.currentTarget.classList.remove("was-validated");

        if (!formData.category || !formData.platform) return;

        dispatch(submitForm(formData));
    };

    const handleOnchange = (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement>) => {
        const { name, value } = e.target;
        dispatch(setFormData({ ...formData, [name]: value }));
    };

    const handleSelectChange = (key: string) => (val: string) => {
        dispatch(setFormData({ ...formData, [key]: val }));
        setInValidSelect(prevState => ({ ...prevState, [key]: false }));
    };

    const isMobile = width < SCREENS.TABLET;

    return (
        <YudlModal
            visible={showForm}
            closeIcon={<Close />}
            centered
            maskClosable={false}
            onCancel={() => dispatch(setFormState(false))}
            footer={null}
            width={isMobile ? "100%" : 600}
        >
            <div className="px-3 py-2">
                <p className="display-6 text-theme">Want a more customized</p>
                <p className="display-3 text-theme fw-bold">DESIGN?</p>
                <form onSubmit={handleSubmit} noValidate>
                    <div className="mt-5">
                        <YudlInput
                            value={formData.productName}
                            onChange={handleOnchange}
                            name="productName"
                            label="Product Name"
                            placeholder="Enter the name of the product here"
                            invalidFeedback="* required"
                            title="* required"
                            required
                        />
                        <YudlTextArea
                            value={formData.description}
                            onChange={handleOnchange}
                            name="description"
                            label="Brief description of the product"
                            placeholder="Tell us a little more about the product"
                            invalidFeedback="* required"
                            title="* required"
                            rows={2}
                            required
                        />
                        <YudlSelect
                            value={formData.platform}
                            onChange={handleSelectChange("platform")}
                            labelField={"title"}
                            valueField={"title"}
                            label="What platform do you want to build your product"
                            placeholder="Is it a mobile app, a website, or both"
                            invalidFeedback="* required"
                            isInvalid={inValidSelect.platform}
                            title="* required"
                            options={PLATFORMS}
                        />
                        <YudlSelect
                            onChange={handleSelectChange("category")}
                            value={formData.category}
                            labelField={"title"}
                            valueField={"title"}
                            label="What is your product category"
                            placeholder="What is kind of solution are you building"
                            invalidFeedback="* required"
                            isInvalid={inValidSelect.category}
                            title="* required"
                            options={CATEGORY}
                        />
                        <YudlInput
                            value={formData.type}
                            onChange={handleOnchange}
                            name="type"
                            label="What is your product type"
                            placeholder="What is kind of service would be provided"
                            invalidFeedback="* required"
                            title="* required"
                            required
                        />
                        <YudlInput
                            value={formData.email}
                            onChange={handleOnchange}
                            name="email"
                            label="Contact Email"
                            type={"email"}
                            placeholder="youremailaddress@email.com"
                            invalidFeedback="* required"
                            title="* A valid email is required"
                            required
                        />
                        <YudlButton
                            loading={processing}
                            htmlType="submit"
                            className="w-100 mt-5"
                            children="Submit Request"
                        />
                    </div>
                </form>
            </div>
        </YudlModal>
    );
};

export default ContactForm;
